"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
/* global FB */
var react_1 = tslib_1.__importDefault(require("react"));
var prop_types_1 = tslib_1.__importDefault(require("prop-types"));
var attach_script_1 = tslib_1.__importDefault(require("../../../../../common/utils/attach-script"));
var accessible_social_button_1 = tslib_1.__importDefault(require("./accessible-social-button"));
var LIBRARY_URL = 'https://connect.facebook.net/en_US/sdk.js';
var FacebookButton = /** @class */ (function (_super) {
    tslib_1.__extends(FacebookButton, _super);
    function FacebookButton() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.init = function (containerNode) {
            FB.init({ xfbml: true, version: 'v2.5' });
            return new Promise(function (resolve) {
                FB.XFBML.parse(containerNode, resolve);
            });
        };
        return _this;
    }
    FacebookButton.prototype.attachScript = function () {
        if (window.FB) {
            return Promise.resolve();
        }
        return (0, attach_script_1.default)(LIBRARY_URL);
    };
    FacebookButton.prototype.render = function () {
        var _a = this.props, cardData = _a.cardData, isAccessible = _a.isAccessible, facebookButtonTitle = _a.facebookButtonTitle;
        return (react_1.default.createElement(accessible_social_button_1.default, { isAccessible: isAccessible, attachScript: this.attachScript, title: facebookButtonTitle, initButton: this.init },
            react_1.default.createElement("div", { className: "fb-like", "data-href": cardData.url, "data-layout": "button", "data-action": "like" })));
    };
    FacebookButton.propTypes = {
        cardData: prop_types_1.default.object,
        isAccessible: prop_types_1.default.bool,
        facebookButtonTitle: prop_types_1.default.string,
    };
    return FacebookButton;
}(react_1.default.Component));
exports.default = FacebookButton;
//# sourceMappingURL=facebook.js.map